import { ErrorResponse } from "@app/core/models/error-response.model";
import { KeyValueModel } from "@app/shared/models/common/key-value.model";
import { createAction, props } from "@ngrx/store";

export const GetBackgroundList = createAction("[Background] GetBackgroundList");
export const GetBackgroundListSuccess = createAction("[Background] GetBackgroundListSuccess", props<{response: KeyValueModel[]}>());
export const GetBackgroundListError = createAction("[Background] GetBackgroundListError", props<{ response: ErrorResponse }>());

export const Clear = createAction("[Background] Clear");
